import { stringify } from 'qs';
import request from '@/utils/request';
import { loginCompany, loginOrg } from '@/utils/LoginContext';

export async function reviewConfig(payload) {
  return request(`/iwms-wms/wms/reviewConfig`, {
    method: 'POST',
    body: payload
  })
}

export async function getreviewConfig(payload) {
  return request(`/iwms-wms/wms/reviewConfig/${payload.uuid}`, {
    method: 'GET',
  })
}

export async function deletereviewConfig(payload) {
  return request(`/iwms-wms/wms/reviewConfig/delete?uuid=${payload.uuid}`, {
    method: 'DELETE',
  })
}

export async function modify(payload) {
  return request(`/iwms-wms/wms/reviewConfig/modify`, {
    method: 'POST',
    body: payload
  })
}

export async function offline(payload) {
  return request(`/iwms-wms/wms/reviewConfig/offline?uuid=${payload.uuid}`, {
    method: 'POST',
  })
}

export async function online(payload) {
  return request(`/iwms-wms/wms/reviewConfig/online?uuid=${payload.uuid}`, {
    method: 'POST',
  })
}

export async function page(payload) {
  return request(`/iwms-wms/wms/reviewConfig/page`, {
    method: 'POST',
    body: payload
  })
}

export async function verifycontainer(payload) {
  return request(`/iwms-wms/wms/onlinereview/verifycontainer?companyUuid=${loginCompany().uuid}&containerBarcode=${payload.containerBarcode}&dcUuid=${loginOrg().uuid}`, {
    method: 'POST'
  })
}

export async function review(payload) {
  return request(`/iwms-wms/wms/onlinereview/review`, {
    method: 'POST',
    body: payload
  })
}

export async function weighing(payload) {
  return request(`/iwms-wms/wms/onlinereview/weighing`, {
    method: 'POST',
    body: payload
  })
}

export async function getTemp(payload) {
  return request(`/iwms-wms/wms/onlinereview/getTemp`, {
    method: 'POST',
    body: payload
  })
}
export async function exception(payload) {
  return request(`/iwms-wms/wms/onlinereview/exception`, {
    method: 'POST',
    body: payload
  })
}
export async function queryexception(payload) {
  return request(`/iwms-wms/wms/onlinereview/queryexception?containerBarcode=${payload.containerBarcode}&dcUuid=${loginOrg().uuid}`, {
    method: 'GET',
  })
}

export async function removeexception(payload) {
  return request(`/iwms-wms/wms/onlinereview/removeexception?containerBarcode=${payload.containerBarcode}&dcUuid=${loginOrg().uuid}&pickupBillNumber=${payload.pickupBillNumber}`, {
    method: 'POST',
  })
}

export async function verify(payload) {
  return request(`/iwms-wms/wms/review/verifybarcode`, {
    method: 'POST',
    body: payload
  })
}

export async function verifypick(payload) {
  return request(`/iwms-wms/wms/review/verifypick`, {
    method: 'POST',
    body: payload
  })
}

export async function getbarcode(payload) {
  return request(`/iwms-wms/wms/review/getbarcode?companyUuid=${payload.companyUuid}&containerTypeUuid=${payload.containerTypeUuid}&dcUuid=${payload.dcUuid}&barcode=${payload.barcode}`, {
    method: 'POST',
    body: payload.store
  })
}

export async function reviewblack(payload) {
  return request(`/iwms-wms/wms/review`, {
    method: 'POST',
    body: payload
  })
}

export async function diff(payload) {
  return request(`/iwms-wms/wms/review/diff`, {
    method: 'POST',
    body: payload
  })
}

export async function queryFull(payload) {
  return request(`/iwms-wms/wms/review/query`, {
    method: 'POST',
    body: payload
  })
}

export async function queryprinturl(payload) {
  return request(`/iwms-wms/wms/review/queryprinturl`, {
    method: 'POST',
    body: payload
  })
}

export async function batchreview(payload) {
  return request(`/iwms-wms/wms/review/batchreview`, {
    method: 'POST',
    body: payload
  })
}

export async function batchremoveexception(payload) {
  return request(`/iwms-wms/wms/onlinereview/batchremoveexception`, {
    method: 'POST',
    body: payload
  })
}

export async function getbycarrier(payload) {
  return request(`/iwms-wms/wms/reviewConfig/getbycarrier?carrierUuid=${payload.carrierUuid}&dcUuid=${payload.dcUuid}`)
}

export async function reviewBatch(payload) {
  return request(`/iwms-wms/wms/review/batch/review`, {
    method: 'POST',
    body: payload
  })
}

export async function savePromptTone(payload) {
  return request(`/iwms-wms/wms/reviewConfig/savePromptTone`, {
    method: 'POST',
    body: payload
  })
}

export async function getPromptToneByDc(payload) {
  return request(`/iwms-wms/wms/reviewConfig/getPromptToneByDc?dcUuid=${payload.dcUuid}`, {
    method: 'GET',
  })
}